import { render, staticRenderFns } from "./ApprovalRequestsPage.vue?vue&type=template&id=0ead0fb5&scoped=true&lang=pug"
import script from "./ApprovalRequestsPage.vue?vue&type=script&lang=js"
export * from "./ApprovalRequestsPage.vue?vue&type=script&lang=js"
import style0 from "./ApprovalRequestsPage.vue?vue&type=style&index=0&id=0ead0fb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ead0fb5",
  null
  
)

export default component.exports